import Vue from "vue";

Vue.config.devtools = true;

import BootstrapVue from "bootstrap-vue";
Vue.use(BootstrapVue);

import VTooltip from "v-tooltip";
Vue.use(VTooltip, {
  // Default events that trigger the tooltip
  defaultTrigger: "hover focus click",
});

import "./css/bootstrap-corrected.css"; // Version corrigée (suppression du @page { a3 })
import "bootstrap-vue/dist/bootstrap-vue.css";
import { store } from "./store/store.js";
import { i18n } from "./i18n.js";
import App from "./App.vue";

Vue.config.productionTip = false;

new Vue({
  i18n,
  store,
  render: h => h(App)
}).$mount("#app");
